"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Autocomplete_1 = tslib_1.__importDefault(require("@mui/material/Autocomplete"));
const AutocompleteInput_1 = tslib_1.__importDefault(require("../AutocompleteInput"));
function AutocompleteMulti({ getOptionLabel, isOptionEqualToValue, loading = false, options, InputProps = {}, renderOption, renderTags, ...restProps }) {
    return (react_1.default.createElement(Autocomplete_1.default, { getOptionLabel: getOptionLabel, isOptionEqualToValue: isOptionEqualToValue, loading: loading, multiple: true, options: options, renderInput: (params) => react_1.default.createElement(AutocompleteInput_1.default, { ...{ loading, ...params, ...InputProps } }), renderOption: renderOption, renderTags: renderTags, ...restProps }));
}
exports.default = AutocompleteMulti;
